<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <v-row>
        <v-col>
          <v-data-table class="category" :headers="headersCat" :items="endCategory" :hide-default-footer="true"
            :items-per-page="-1">
            <template v-slot:top>
              <h5 class="text-center">Окончание срока действия кв. категории</h5>
              <v-divider style="margin: 0" class="border-opacity-100"></v-divider>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <a :href="$model.wwwroot +
                    '/blocks/manage_groups/private_case/add_contr.php?people=' +
                    item.id
                    " target="_blank">
                    {{ item.name }}
                  </a>
                </td>
                <td>{{ item.date_end }}</td>
              </tr>
            </template>

            <template v-slot:bottom> </template>
          </v-data-table>


        </v-col>
        <v-col>
          <v-data-table class="category" :headers="headersPass" :items="changePassport" :hide-default-footer="true"
            :items-per-page="-1">
            <template v-slot:top>
              <h5 class="text-center">Необходимо поменять паспорт</h5>
              <v-divider style="margin: 0" class="border-opacity-100"></v-divider>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <a :href="$model.wwwroot +
                    '/blocks/manage_groups/private_case/add_contr.php?people=' +
                    item.id
                    " target="_blank">
                    {{ item.name }}
                  </a>
                </td>
                <td>{{ item.birthday }}</td>
              </tr>
            </template>

            <template v-slot:bottom> </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-account-group"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Сотрудники</span>
      </v-col>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "staffWidget",
  data() {
    return {
      headersCat: [
        {
          title: "ФИО",
          align: "start",
          sortable: false,
          key: "name",
        },
        {
          title: "Дата окончания",
          key: "date_end",
          align: "start",
          sortable: false,
        },
      ],
      headersPass: [
        {
          title: "ФИО",
          align: "start",
          sortable: false,
          key: "name",
        },
        {
          title: "ДР",
          key: "date_end",
          align: "start",
          sortable: false,
        },
      ],
      endCategory: [],
      changePassport: [],
      load: false
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.endCategory.length == 0 && this.changePassport.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/staffInfo/get"
        )
        .then((response) => {
          this.endCategory = response.data.endCategory;
          this.changePassport = response.data.changePassport;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {

  .category th,
  .category td {
    height: auto;
  }
}
</style>
